import stbAPIGateway from '../../../../services/stbAPIGateway';

export const putCsvZip = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const response = await stbApi.putHubCsvZip(clientSid);
  return response;
};
